import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";

import { Button } from "../Buttons/Button";
import { DashboardIconButton } from "./DashboardIconButton";

const EDIT_BUTTON_CLASS = "animate-fade-in !py-1 !px-2";

type DashboardEditControlsProps = {
  editing: boolean;
  onStart: () => void;
  onCancel: () => void;
  onFinish: () => void;
  onReset: () => void;
};

export const DashboardEditControls: React.FC<DashboardEditControlsProps> = ({ editing, onStart, onCancel, onFinish, onReset }) => {
  if (!editing) {
    return <DashboardIconButton leftIcon={faPenToSquare} aria-label="Customise" onClick={onStart} />;
  }

  return (
    <div className="flex items-center gap-2 mr-2">
      <Button className={EDIT_BUTTON_CLASS} variant="ghost" size="sm" onClick={onReset}>Reset to default</Button>
      <Button className={EDIT_BUTTON_CLASS} variant="secondary" size="sm" onClick={onCancel}>Cancel</Button>
      <Button className={EDIT_BUTTON_CLASS} variant="primary" size="sm" onClick={onFinish}>Done</Button>
    </div>
  );
};
